import { useMemo } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';

export function useInitBalloonManager(): YMaps.BalloonManager {
  const { ymaps } = useMapStoreContext();

  return useMemo(() => new ymaps.BalloonManager(), [ymaps.BalloonManager]);
}
